import { render, staticRenderFns } from "./IdentificationType.vue?vue&type=template&id=ea16e658&scoped=true&"
import script from "./IdentificationType.vue?vue&type=script&lang=js&"
export * from "./IdentificationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea16e658",
  null
  
)

export default component.exports